export class DatatableParameters {
    constructor(
        public columns: any[],
        public length: number,
        public order: any[],
        public start: number
    ) { }
}
